module.exports = __webpack_public_path__ + "static/media/UnknownStatus.019d5663.png";